import React from 'react';

function BlockD() {
  const workingCapitalData = [
    {
      slNo: 1,
      item: 'Raw Materials & Components and Packing Materials',
      opening: 0,
      closing: 0
    },
    {
      slNo: 2,
      item: 'Fuels & Lubricants',
      opening: 0,
      closing: 0
    },
    {
      slNo: 3,
      item: 'Spares, Stores and Others',
      opening: 0,
      closing: 0
    },
    {
      slNo: 4,
      item: 'Sub-total(1 to 3)',
      opening: 0,
      closing: 0
    },
    {
      slNo: 5,
      item: 'Semi-Finished Goods/Work-in-Progress',
      opening: 0,
      closing: 0
    },
    {
      slNo: 6,
      item: 'Finished Goods',
      opening: 0,
      closing: 0
    },
    {
      slNo: 7,
      item: 'Total Inventory (4 to 6)',
      opening: 0,
      closing: 0
    },
    {
      slNo: 8,
      item: 'Cash in Hand & at Bank',
      opening: 0,
      closing: 0
    },
    {
      slNo: 9,
      item: 'Sundry Debtors',
      opening: 0,
      closing: 0
    },
    {
      slNo: 10,
      item: 'Other Current Assets',
      opening: 0,
      closing: 0
    },
    {
      slNo: 11,
      item: 'Total Current Assets (7 to 10)',
      opening: 0,
      closing: 0
    },
    {
      slNo: 12,
      item: 'Sundry Creditors',
      opening: 0,
      closing: 0
    },
    {
      slNo: 13,
      item: 'Over Draft, Cash Credit, Other Short Term Loan from banks & other financial institutions',
      opening: 0,
      closing: 0
    },
    {
      slNo: 14,
      item: 'Other Current Liabilities',
      opening: 0,
      closing: 0
    },
    {
      slNo: 15,
      item: 'Total Current Liabilities(12 to 14)',
      opening: 0,
      closing: 0
    },
    {
      slNo: 16,
      item: 'Working Capital(11 - 15)*',
      opening: 0,
      closing: 0
    },
    {
      slNo: 17,
      item: 'Outstanding Loans(excluding interest but including deposits)**',
      opening: 0,
      closing: 0
    }
  ];

  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  return (
    <>
      <style>
        {`
          .block-d-header {
            background-color: #e3f2fd;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
          }
          .page-title {
            color: #1976d2;
            font-size: 24px;
            font-weight: bold;
            margin: 0;
          }
          .reference-numbers {
            color: #333;
            font-size: 14px;
            font-weight: 500;
            margin: 0;
          }
          .working-capital-table {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
          }
          .table-header {
            background-color: #f8f9fa;
            border-bottom: 2px solid #1976d2;
          }
          .table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: 600;
            font-size: 14px;
            text-align: center;
            vertical-align: middle;
            padding: 12px 8px;
            border: 1px solid #dee2e6;
          }
          .table td {
            font-size: 13px;
            text-align: right;
            vertical-align: middle;
            padding: 10px 8px;
            border: 1px solid #dee2e6;
          }
          .table td:first-child {
            text-align: center;
            font-weight: 600;
            width: 60px;
          }
          .table td:nth-child(2) {
            text-align: left;
            font-weight: 500;
            min-width: 300px;
          }
          .table td:nth-child(3),
          .table td:nth-child(4) {
            text-align: right;
            font-weight: 500;
            width: 120px;
          }
          .subtotal-row {
            background-color: #f8f9fa;
            font-weight: 600;
          }
          .total-row {
            background-color: #e3f2fd;
            font-weight: bold;
            color: #1976d2;
          }
          .footnotes-section {
            background-color: #fff3cd;
            border: 1px solid #ffeaa7;
            border-radius: 6px;
            padding: 15px;
            margin-top: 20px;
          }
          .footnote {
            color: #856404;
            font-size: 13px;
            margin-bottom: 8px;
          }
          .footnote:last-child {
            margin-bottom: 0;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="block-d-header">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="page-title">D: Working Capital and Loans</h1>
            </div>
            <div className="col-md-6 text-end">
              <p className="reference-numbers">DSL No : 404936</p>
              <p className="reference-numbers">PSL No : 31186</p>
            </div>
          </div>
        </div>

        {/* Working Capital Table */}
        <div className="working-capital-table">
          <div className="table-responsive">
            <table className="table table-bordered mb-0">
              <thead className="table-header">
                <tr>
                  <th>SI No (1)</th>
                  <th>Items (2)</th>
                  <th>Opening (Rs.) (3)</th>
                  <th>Closing (Rs.) (4)</th>
                </tr>
              </thead>
              <tbody>
                {workingCapitalData.map((row, index) => (
                  <tr key={index} className={
                    row.item.includes('Sub-total') || row.item.includes('Total Inventory') || 
                    row.item.includes('Total Current Assets') || row.item.includes('Total Current Liabilities') 
                      ? 'subtotal-row' : ''
                  }>
                    <td>{row.slNo}</td>
                    <td>{row.item}</td>
                    <td>{formatNumber(row.opening)}</td>
                    <td>{formatNumber(row.closing)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footnotes Section */}
        <div className="footnotes-section">
          <div className="footnote">
            <strong>*</strong> Give reasons in the footnote for negative values and abnormal variation in opening and closing values.
          </div>
          <div className="footnote">
            <strong>**</strong> If outstanding loans include interest, a footnote may be given
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row mt-4">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button type="button" className="btn btn_orange mx-1">
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Save
            </button>
            <button type="reset" className="btn btn_orange mx-1">
              Reset
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button type="button" className="btn btn_orange mx-1">
              Back 
              <i className="fa fa-angle-left ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockD; 